import React from "react";

import { Route, Routes } from "react-router-dom";

import { selectEnvironmentDomainsEnabled } from "Reducers/featureFlags/featureFlags.selectors";
import { useAppSelector } from "Store/hooks";

import DomainsSettingsPage from "./domains/Routes";
import GeneralSettingsPage from "./general/Page";
import Page from "./Page";
import VariablesSettings from "./variables/Routes";

const EnvironmentSettingsRoutes = () => {
  const environmentDomainsEnabled = useAppSelector(
    selectEnvironmentDomainsEnabled
  );

  return (
    <Page entries={["general", "variables", "access", "domains"]}>
      <Routes>
        <Route path="variables/*" element={<VariablesSettings />} />
        {environmentDomainsEnabled && (
          <Route path="domains/*" element={<DomainsSettingsPage />} />
        )}
        <Route path="" element={<GeneralSettingsPage />} />
      </Routes>
    </Page>
  );
};

export default EnvironmentSettingsRoutes;
